module.exports = __webpack_public_path__ + "static/media/ic_radio_button.b5078896.svg";